import { TranslateLike } from './helper';
import { getEnumValueLabel } from './helper';

const SUBSCRIPTION_BILLING_CYCLE_KEY_MAP: Record<Pay.DurationNum, string> = {
  0: 'subscription.billingCycle.notAdd',
  1: 'subscription.billingCycle.monthly',
  3: 'subscription.billingCycle.quarterly',
  6: 'subscription.billingCycle.sixMonths',
  12: 'subscription.billingCycle.annual',
};

export const getSubscriptionBillingCycleLabel = (t: TranslateLike, durationNum?: Pay.DurationNum) =>
  getEnumValueLabel(t, durationNum, SUBSCRIPTION_BILLING_CYCLE_KEY_MAP);
